import { render, staticRenderFns } from "./customer-edit.vue?vue&type=template&id=4df89402&scoped=true&"
import script from "./customer-edit.vue?vue&type=script&lang=ts&"
export * from "./customer-edit.vue?vue&type=script&lang=ts&"
import style0 from "./customer-edit.vue?vue&type=style&index=0&id=4df89402&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df89402",
  null
  
)

export default component.exports